"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _nestedSelectFilter = _interopRequireDefault(require("./base/nested-select-filter.store"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _timeFilter = require("../../utils/filters/time-filter.utils");
var _filters = require("../../constants/filters.constants");
var _dec, _dec2, _dec3, _class, _descriptor;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TimeFilter = exports.default = (_dec = _mobx.observable.shallow, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class = function (_NestedSelectFilter) {
  (0, _inherits2.default)(TimeFilter, _NestedSelectFilter);
  function TimeFilter(filterData, $env) {
    var _this;
    (0, _classCallCheck2.default)(this, TimeFilter);
    _this = _callSuper(this, TimeFilter, [$env]);
    _this.id = _filters.FILTER_MAP.TIME;
    (0, _initializerDefineProperty2.default)(_this, "data", _descriptor, (0, _assertThisInitialized2.default)(_this));
    _this.initialize(filterData);
    return _this;
  }
  (0, _createClass2.default)(TimeFilter, [{
    key: "initialize",
    value: function initialize(data, query, withCommit) {
      if (query === void 0) {
        query = '';
      }
      if (withCommit === void 0) {
        withCommit = true;
      }
      this.data = data;
      this.uncommittedState = (0, _timeFilter.initializeState)(data);
      if (withCommit) {
        this.state = this.uncommittedState;
      }
      if (query) {
        this.update(query, withCommit);
      }
    }
  }, {
    key: "resetType",
    value: function resetType(legType, index, withCommit) {
      if (legType === void 0) {
        legType = _filters.FLIGHT_LEG_TYPE_MAP.ORIGIN;
      }
      if (withCommit === void 0) {
        withCommit = false;
      }
      if ((0, _includes2.default)(_filters.FLIGHT_LEG_TYPE_MAP, legType)) {
        this.uncommittedState = (0, _map2.default)(this.uncommittedState, function (legState, legIndex) {
          if (legIndex === index) {
            var updatedLegState = _objectSpread({}, legState);
            updatedLegState[legType] = (0, _timeFilter.initializeTimeSegments)();
            return updatedLegState;
          }
          return legState;
        });
      }
      if (withCommit) {
        this.state = this.uncommittedState;
      }
    }
  }]);
  return TimeFilter;
}(_nestedSelectFilter.default), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {
      legCount: 2
    };
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initialize", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetType", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "resetType"), _class.prototype)), _class));